import React, {Component} from 'react';
import L from 'leaflet';
import './Map.css';

const rawMapLayerUrl = 'https://gist.githubusercontent.com/jperals/04a7199436bf5d54ee4c224186cffeb3/raw/5f710bae0ba29a18ef943b4297e7c8b16ecf2e14/language-areas.json'

const refinedMapLayerUrl = 'https://gist.githubusercontent.com/jperals/04a7199436bf5d54ee4c224186cffeb3/raw/1ce6ea9d22b413fe40d11890529a2216fd51d845/fences-ca-da-de-en-es-ja-nl-oc-pt-sco-th.json'

const backgroundMapLayerUrl = 'https://api.mapbox.com/styles/v1/jperals/cjri9xpgx1he12sqtw8usp9ia/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoianBlcmFscyIsImEiOiJjajR4NnhwazUwcGdvMzNxbnMzY3Qza3BvIn0.Ae2Eze-ABuDGlilGHthLXQ'

const attribution = L.control.attribution({
  prefix: false
}).addAttribution('&copy; <a href="https://perals.io">Joan Perals</a> 2019 | Using <a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a> | Background map imagery © <a href="https://www.mapbox.com/">Mapbox</a>')

export default class Map extends Component {
  componentDidMount() {

    Promise.all([
      fetch(rawMapLayerUrl)
        .then(buffer => buffer.text())
        .then(text => JSON.parse(text)),
      fetch(refinedMapLayerUrl)
        .then(buffer => buffer.text())
        .then(text => JSON.parse(text)),
      fetch('./legend.json')
        .then(buffer => buffer.text())
        .then(text => JSON.parse(text))
    ])
      .then(([rawGeojson, refinedGeojson, legend]) => {
        const rawMap = L.geoJSON(rawGeojson, {
          style: function (feature) {
            return {
              fillColor: languageColor(feature.properties.language, legend),
              fillOpacity: 0.6,
              weight: 0
            }
          }
        }).bindTooltip(function (layer) {
          return languageName(layer.feature.properties.language, legend)
        }, {
          sticky: true
        })
        const refinedMap = L.geoJSON(refinedGeojson, {
          style: function (feature) {
            return {
              fillColor: languageColor(feature.properties.language, legend),
              fillOpacity: 0.6,
              weight: 0
            }
          }
        }).bindTooltip(function (layer) {
          return languageName(layer.feature.properties.language, legend)
        }, {
          sticky: true
        })
        const backgroundLayer = L.tileLayer(backgroundMapLayerUrl, {
          maxZoom: 18,
          id: 'mapbox.satellite',
          accessToken: 'pk.eyJ1IjoianBlcmFscyIsImEiOiJjajR4NnhwazUwcGdvMzNxbnMzY3Qza3BvIn0.Ae2Eze-ABuDGlilGHthLXQ',
          opacity: 1
        })
        const map = L.map('map', {
          attributionControl: false,
          layers: [rawMap]
        }).setView([25, 2], 2)

        L.control.layers({"Raw": rawMap, "Edited": refinedMap}).addTo(map)
        backgroundLayer.addTo(map)
        attribution.addTo(map)
        if(this.props && typeof this.props.onDataLoaded === 'function') {
          this.props.onDataLoaded()
        }
      })

  }

  render() {
    return (
      <div id="map"></div>
    )
  }
}

function languageColor(languageCode, legend) {
  if (legend[languageCode]) {
    return legend[languageCode].color
  }
}

function languageName(languageCode, legend) {
  if (legend[languageCode]) {
    return legend[languageCode].name
  }
  return '(' + languageCode + ')'
}
